import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

export const timeEntryZone = "Europe/Oslo";
export interface DriverTimeEntry {
  id: string;
  source: string;
  recordedStart: string | null;
  recordedEnd: string | null;
  reported?: {
    start: string;
    end: string;
    breakMinutes: number;
    comment: string;
  };
  voided?: boolean;
  voidReason?: string;
  periodSeconds: number;
}
export interface DriverTimeEntries {
  entries: DriverTimeEntry[];
  accountLinked: boolean;
  timezone: string;
}

/** Picker dates are calendar labels, not browser-zone instants. */
export function timeEntryWeek(date: Date) {
  const day = dayjs.tz(dayjs(date).format("YYYY-MM-DD"), timeEntryZone);
  const monday = day.subtract((day.day() + 6) % 7, "day").format("YYYY-MM-DD");
  const next = dayjs(monday).add(7, "day").format("YYYY-MM-DD");
  return {
    from: dayjs.tz(monday, timeEntryZone).toISOString(),
    to: dayjs.tz(next, timeEntryZone).toISOString(),
    label: `${dayjs(monday).format("DD.MM.YYYY")} – ${dayjs(next).subtract(1, "day").format("DD.MM.YYYY")}`,
  };
}
export function todayInOslo() {
  return new Date(dayjs().tz(timeEntryZone).format("YYYY-MM-DD") + "T12:00:00");
}
export function timeEntryStamp(value?: string | null) {
  return value
    ? dayjs(value).tz(timeEntryZone).format("DD.MM.YYYY HH:mm")
    : "—";
}
export function timeEntryDuration(seconds: number) {
  const minutes = Math.round(Math.max(0, seconds) / 60);
  return `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, "0")}`;
}
export function overlappingTimeEntries(rows: DriverTimeEntry[]) {
  const overlaps = new Set<string>();
  const closed = rows.filter(
    (row) => !row.voided && (row.reported?.end || row.recordedEnd),
  );
  const interval = (row: DriverTimeEntry) => [
    Date.parse(row.reported?.start || row.recordedStart || ""),
    Date.parse(row.reported?.end || row.recordedEnd || ""),
  ];
  closed.forEach((row, i) => {
    const [start, end] = interval(row);
    closed.slice(i + 1).forEach((other) => {
      const [otherStart, otherEnd] = interval(other);
      if (start < otherEnd && otherStart < end) {
        overlaps.add(row.id);
        overlaps.add(other.id);
      }
    });
  });
  return overlaps;
}
